import axios from 'axios';

const BASE = '/api/v1/paie/configuration';

const unwrap = (r: { data: any }) => r.data?.data ?? r.data?.donnees ?? r.data;

export const configurationApi = {
  obtenirPeriode: (annee: number, mois: number) =>
    axios.get(`${BASE}/${annee}/${mois}`).then(unwrap),

  listerParametres: () =>
    axios.get(`${BASE}/parametres`).then(unwrap),

  creerParametre: (data: any) =>
    axios.post(`${BASE}/parametres`, data).then(unwrap),

  modifierParametre: (id: string, data: { valeur: string }) =>
    axios.put(`${BASE}/parametres/${id}`, data).then(unwrap),

  listerRegles: () =>
    axios.get(`${BASE}/regles`).then(unwrap),

  creerRegle: (data: any) =>
    axios.post(`${BASE}/regles`, data).then(unwrap),

  obtenirCNSS: () =>
    axios.get(`${BASE}/cnss`).then(unwrap),

  creerCNSS: (data: any) =>
    axios.post(`${BASE}/cnss`, data).then(unwrap),

  obtenirITS: () =>
    axios.get(`${BASE}/its`).then(unwrap),

  creerITS: (data: any) =>
    axios.post(`${BASE}/its`, data).then(unwrap),

  modifierITS: (id: string, data: any) =>
    axios.put(`${BASE}/its/${id}`, data).then(unwrap),

  obtenirVPS: () =>
    axios.get(`${BASE}/vps`).then(unwrap),

  creerVPS: (data: any) =>
    axios.post(`${BASE}/vps`, data).then(unwrap),

  listerTemplatesPrimes: () =>
    axios.get(`${BASE}/primes/templates`).then(unwrap),

  creerTemplatePrime: (data: any) =>
    axios.post(`${BASE}/primes/templates`, data).then(unwrap),

  modifierTemplatePrime: (id: string, data: any) =>
    axios.put(`${BASE}/primes/templates/${id}`, data).then(unwrap),

  desactiverTemplatePrime: (id: string) =>
    axios.delete(`${BASE}/primes/templates/${id}`).then(unwrap),

  listerTaxes: () =>
    axios.get(`${BASE}/taxes`).then(unwrap),

  creerTaxe: (data: any) =>
    axios.post(`${BASE}/taxes`, data).then(unwrap),

  modifierTaxe: (id: string, data: any) =>
    axios.put(`${BASE}/taxes/${id}`, data).then(unwrap),

  desactiverTaxe: (id: string) =>
    axios.delete(`${BASE}/taxes/${id}`).then(unwrap),

  obtenirTheme: () =>
    axios.get(`${BASE}/theme`).then(unwrap),

  sauvegarderTheme: (slug: string, custom?: Record<string, string>) =>
    axios.put(`${BASE}/theme`, { slug, custom }).then(unwrap),
};
